export const trademarksPage = {
  message: 'OK',
  data: [
    {
      id: '17',
      label: '222222'
    },
    {
      id: '10',
      label: '+58Shop'
    },
    {
      id: '2',
      label: 'Adidas'
    },
    {
      id: '18',
      label: 'Andina'
    },
    {
      id: '14',
      label: 'asd'
    },
    {
      id: '15',
      label: 'asdasd'
    },
    {
      id: '5',
      label: 'New Balance'
    },
    {
      id: '1',
      label: 'Nike'
    },
    {
      id: '19',
      label: 'Pepe'
    },
    {
      id: '20',
      label: 'Pepe'
    },
    {
      id: '8',
      label: 'Prueba'
    },
    {
      id: '9',
      label: 'Prueba1'
    },
    {
      id: '3',
      label: 'Puma'
    },
    {
      id: '11',
      label: 'TELECOMUNICACIONES'
    },
    {
      id: '21',
      label: 'test'
    },
    {
      id: '12',
      label: 'test'
    },
    {
      id: '13',
      label: 'test'
    },
    {
      id: '4',
      label: 'Under Armour'
    }
  ],
  status: 200
}
